import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyThunkApiConfig } from '../../types';

export const searchJobListAction = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('job/searchQuery', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const { data } = await graphqlFunction(params);
    return data?.searchJobs?.docs;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});
